import { render } from "./longTextField.vue?vue&type=template&id=fc0fa35a"
import script from "./longTextField.vue?vue&type=script&lang=js"
export * from "./longTextField.vue?vue&type=script&lang=js"

import "./longTextField.vue?vue&type=style&index=0&id=fc0fa35a&lang=scss"

import exportComponent from "/builds/spsgn/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
